import React from 'react';
import { UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap';

const Starz = () => (
  <div>
    <h2>Starz</h2>
    <p>6 Channels of Premium Starz Content in HD. $11</p>
    <Button outline color="success" id="starztoggle" style={{ marginBottom: '1rem' }}>
      Show/Hide Channel Listing
    </Button>
    <UncontrolledCollapse toggler="#starztoggle">
      <Card>
        <CardBody>
          420 - Starz<br />
          422 - Starz Cinema<br />
          423 - Starz Comedy<br />
          424 - Starz Edge<br />
          425 - Starz in Black<br />
          426 - Starz Kids and Family<br />
        </CardBody>
      </Card>
    </UncontrolledCollapse>
  </div>
);

export default Starz;


// WEBPACK FOOTER //
// ./src/components/sections/services/tv/starz.js